import api from './api'

export default {

    postArticle(id, quantity, variationId) {

        let data = {
            'id': id,
            'quantity': quantity
        }

        if ( variationId ) {
            data.variationId = variationId;
        }

        return api.post('/cart/articles', [ data ])
    },

    postMultipleArticles(articles) {
        return api.post('/cart/articles', articles)
    }
}